export function isDesigningModeEnabled(state) {
  return Boolean(state.report.designingId);
}
